import types from './types'

export const upgrade = () => ({ type: types.ACCOUNT_UPGRADE })

export const loadShopInvoices = () => ({ type: types.DATA_LOAD_SHOP_INVOICES_ATTEMPT })
export const loadShopInvoicesSuccess = (data) => ({ type: types.DATA_LOAD_SHOP_INVOICES_SUCCESS, data })
export const loadShopInvoicesFailure = (message, code) => ({ type: types.DATA_LOAD_SHOP_INVOICES_FAILURE, message, code })

export const loadBillingDetails = () => ({
    type: types.BILLING_DETAILS_LOAD_ATTEMPT,
})

export const loadBillingDetailsSuccess = (data) => ({
    type: types.BILLING_DETAILS_LOAD_SUCCESS,
    data,
})

export const loadBillingDetailsFailure = (message, code) => ({
    type: types.BILLING_DETAILS_LOAD_FAILURE,
    message,
    code,
})

export const updateBillingDetails = (billingDetails) => ({
    type: types.BILLING_DETAILS_UPDATE_ATTEMPT,
    billingDetails,
})

export const updateBillingDetailsSuccess = (data) => ({
    type: types.BILLING_DETAILS_UPDATE_SUCCESS,
    data,
})

export const updateBillingDetailsFailure = (message, code) => ({
    type: types.BILLING_DETAILS_UPDATE_FAILURE,
    message,
    code,
})